export default __webpack_public_path__ + "static/media/pic95.0fc6d078.jpg";